import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { ThumbnailBig, FooterSection } from "@components";
import "./WhistleBlowingCorporateGovernance.scss";
import { CorporateGovernanceAPI } from "@api";
import { useTranslation } from "react-i18next";
import { TitleComponent } from "../../../common/components/TitleComponent";
import { Accordion } from "../../../common/components";
import MyMenu from "../MyMenu";

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const CorporateGovernanceContainer = styled.div`
  margin-top: 56px;
  padding: 24px 119px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`;

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const H2 = styled.h2`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  color: #5e514d;
`;

const P = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 150%;
  color: #5e514d;
`;

const WhistleBlowingCorporateGovernance = function () {
  const { t } = useTranslation();
  const [data, setdata] = useState({});
  const [isLoading, setisLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async function () {
    setisLoading(true);
    const { data } = await CorporateGovernanceAPI("whistleblowing-system");
    setdata(data.data);
    setisLoading(false);
  };

  return (
    <div>
      <TitleComponent title={data.judulBannerWS} />
      <Container>
        <Desktop>
          <ThumbnailBig
            title={isLoading ? "" : data.judulBannerWS}
            desc={isLoading ? "" : data.deskripsiBannerWS}
            img={isLoading ? "" : data.imageBannerDesktopWS}
          />
        </Desktop>
        <Mobile>
          <ThumbnailBig
            title={isLoading ? "" : data.judulBannerWS}
            desc={isLoading ? "" : data.deskripsiBannerWS}
            img={isLoading ? "" : data.imageBannerMobileWS}
          />
        </Mobile>
      </Container>

      <CorporateGovernanceContainer className="container-fluid">
        <div className="m-0 row d-flex align-items-start">
          <div className="p-0 col-lg-9 col-12">
            <div className="row">
              <div className="p-3 col-12">
                <H2>{data.judulWS}</H2>
                <P
                  dangerouslySetInnerHTML={{
                    __html: data.deskripsiWS,
                  }}
                ></P>
              </div>
              {isLoading
                ? []
                : data.blockDataWS.map((item, index) => {
                    return (
                      <Accordion key={index} title={item.judulAccordionWS}>
                        {item.deskripsiAccordionWS}
                      </Accordion>
                    );
                  })}
            </div>
          </div>
          <div className="d-none d-lg-block col">
            <MyMenu active={5} />
          </div>
        </div>
      </CorporateGovernanceContainer>
      <FooterSection currentPage={t("whistleblowing_system")} />
    </div>
  );
};

export default WhistleBlowingCorporateGovernance;
